import { Bold } from '@serodigital/ui-components';
import * as React from 'react';
import { ScheduleCard } from './scheduleCard';

export function ZonesList({ zoneName, zones, onClickSchedule, zoneId }) {
  return (
    <div data-qa="zone-list">
      <Bold className="capitalize">{zoneName}</Bold>
      <div className="flex flex-row flex-wrap">
        {zones?.map((zone, index) => (
          <ScheduleCard
            key={`${zoneName}-${index}`}
            {...zone}
            onClick={() => onClickSchedule({ ...zone, zoneId, index })}
          />
        ))}
      </div>
    </div>
  );
}
